import React from 'react';
import { Text, TextProps } from '@mantine/core';
import { P2Medium as P2MediumStyle } from 'theme/typography';

interface P2MediumProps extends TextProps {
  customStyle?: React.CSSProperties;
  children: React.ReactNode; // Explicitly define the children prop
}

/**
 * Applies the P2Medium typography style.
 */
const P2Medium: React.FC<P2MediumProps> = ({ children, customStyle, ...restProps }) => {
  return (
    <Text {...restProps} style={{ ...P2MediumStyle, ...customStyle }}>
      {children}
    </Text>
  );
};

export default P2Medium;
